import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ScanScore } from 'src/interfaces/ScanScore';
import { getScansScore } from 'src/services/scan/ScansService';

export const useGetScansScore = (ids: string[], viewId?: string): UseQueryResult<ScanScore[]> => {
	const sortedIds = [...ids].sort();
	return useQuery<ScanScore[], Error>({
		queryKey: ['scans-score', sortedIds, viewId ?? 'none'],
		queryFn: () => getScansScore(sortedIds, viewId),
		enabled: !!ids?.length
	});
};
